define(
    'providers/dataprovider.documents',[
        "services/config"
    ],
    function(config) {

        function getDocumentDefaultSchema() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-document-default-schema",
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getLibraryDocumentSchema(libraryId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-library-document-schema",
                    data: { libraryId: libraryId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getLibraryModifyFieldDocumentSchema(libraryId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-modifyfield-document-schema",
                    data: { libraryId: libraryId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getDocumentDetails(documentId, libraryId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-document-details",
                    data: { documentId: documentId, libraryId: libraryId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getOpenDocumentBaseUrl() {
            return getUrl("documents/");
        }
        function getDocumentPreview(documentId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-document-preview",
                    data: { documentId: documentId },
                    success: function (result, statusCode) {

                        var encodingString = String.format("data:{0}", result.mimeType);
                        if (result.charset) {
                            encodingString += ";charset=" + result.charset;
                        }
                        if (result.encoding) {
                            encodingString += ";" + result.encoding;
                        }

                        var obj = { encoding: encodingString + ",", data: result.encoding ? result.data : encodeURI(result.data) };


                        deferred.resolve(obj, statusCode);
                    },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getShareWithItems() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-sharewithitems",
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getSharedMessage(recipientlinkId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-documents-shared-message",
                    data: { recipientlinkId: recipientlinkId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getSharedDocuments(lastdays, isMy) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-documents-sharedmails-details",
                    data: { my: (!isMy ? "" : "/my"), lastdays: lastdays },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getSharedDocumentDetails(documentshareId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-documents-shared-details",
                    data: { documentshareId: documentshareId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getDocumentsFromFolder(folderId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-documents-from-folder",
                    data: { folderId: folderId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getDocumentsCheckedOut() {            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-documents-checkedout",
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getDocumentVersion(documentId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-document-version",
                    data: { documentId: documentId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getDocumentHistory(documentId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-document-history",
                    data: { documentId: documentId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getDocumentDetailsWindows(documentId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-document-details-windows",
                    data: { documentId: documentId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getDocumentHpvLinks(documentIds) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-document-hpv-links",
                    data: { documentIds: documentIds },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getDocumentPublicLinks(data) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-document-public-links",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getDocumentGeneratedPublicLinks(documentShareId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-document-generated-public-links",
                    data: { documentShareId: documentShareId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getDeletedDocumentsByFolderId(folderId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-deleted-documents-by-folder-id",
                    data: { folderId: folderId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updateDocumentField(documentId, libraryId, field, value) {
            var deferred = $.Deferred();
            var fieldMap = {};            

            if (_.isDate(value)) value = moment(value).format();

            fieldMap[field] = value;

            amplify.request({
                resourceId: "update-document-field",
                data: { documentId: documentId, libraryId: libraryId, fieldMap: fieldMap },                
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });

            return deferred.promise();
        }
        function updateDocumentClassField(documentId, libraryId, field, value, initVersion) {
            var deferred = $.Deferred();
            var fieldMap = {};
            
            if (arguments.length > 4) //must accept 0. dont change to !initVersion
                fieldMap = { "documentClass": value, "version": initVersion };
            else
                fieldMap = { "documentClass": value };

            amplify.request({
                resourceId: "update-document-field",
                data: { documentId: documentId, libraryId: libraryId, fieldMap: fieldMap },
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });

            return deferred.promise();
        }
        function flagDocument(documentId) {
            return markDocument(documentId, "flag-document");
        }
        function unflagDocument(documentId) {
            return markDocument(documentId, "unflag-document");
        }
        function favouriteDocument(documentId) {
            return markDocument(documentId, "favourite-document");
        }
        function unfavouriteDocument(documentId) {
            return markDocument(documentId, "unfavourite-document");
        }

        function canDownload(documents) { return canPerformAction("download", documents); }
        function canShare(documents) { return canPerformAction("share", documents); }
        function canSaveNewVersion(documents) { return canPerformAction("save-new-version", documents); }
        function canCopyDocuments(documents) { return canPerformAction("copy", documents); }
        function canMoveDocuments(documents) { return canPerformAction("move", documents); }
        function canReplaceFile(documents) { return canPerformAction("replace-file", documents); }
        function canModifyField(documents) { return canPerformAction("modify-field", documents); }
        function canCheckout(documents) { return canPerformAction("checkout", documents); }
        function canCheckin(documents) { return canPerformAction("checkin", documents); }
        function canCancelCheckout(documents) { return canPerformAction("cancel-checkout", documents); }
        function canDelete(documents) { return canPerformAction("delete", documents); }
        function canUndelete(documents) { return canPerformAction("undelete", documents); }
        function canPurgeDeleted(documents) { return canPerformAction("purge-deleted", documents); }
        function canRestorePriorRevision(documents) { return canPerformAction("restore-prior-revision", documents); }

        function copyDocuments(documentLocations, toFolderId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "copy-documents",
                    data: { documents: documentLocations, folderId: toFolderId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function copyDocumentsTemplate(documentLocations, toFolderId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "copy-documents-template",
                    data: { documents: documentLocations, folderId: toFolderId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function moveDocuments(documentLocations, toFolderId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "move-documents",
                    data: { documents: documentLocations, folderId: toFolderId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function deleteDocuments(documents) { return performAction("delete", documents); }
        function undeleteDocuments(documents) { return performAction("undelete", documents); }
        function purgedeletedDocuments(documents) { return performAction("purge", documents); }
        function checkoutDocuments(documents) { return performAction("check-out", documents); }
        function cancelCheckOutDocuments(documents) { return performAction("cancel-checkout", documents); }
        function flagDocuments(documents) { return performAction("flag", documents); }
        function unflagDocuments(documents) { return performAction("unflag", documents); }
        function favouriteDocuments(documents) { return performAction("favourite", documents); }
        function unfavouriteDocuments(documents) { return performAction("unfavourite", documents); }
        function shareDocuments(documents) { return performAction("share", documents); }
        function modifyFieldDocuments(toModify, documents) { return performModifyAction("modify-field", toModify, documents); }
        function replaceFileDocuments(documentId, data) {
            var url = getUrl(String.format("documents/action/replace/{0}", documentId));
            return performAddReplaceFileCheckOutAction(url, data);
        }
        function checkInDocuments(documentId, data) {
            var url = getUrl(String.format("documents/action/checkin/{0}", documentId));
            return performAddReplaceFileCheckOutAction(url, data);
        }
        function addFileDocuments(folderId, data) {
            var url = getUrl(String.format("documents/action/add/{0}", folderId));
            return performAddReplaceFileCheckOutAction(url, data);
        }
        function addFileNewVersionDocuments(documentId, data) {
            var url = getUrl(String.format("documents/action/savenewversion/{0}/upload", documentId));
            return $.Deferred(function (deferred) {
                $.ajax({
                    url: url,
                    type: "POST",
                    data: data,
                    mimeType: "multipart/form-data",
                    contentType: false,
                    cache: false,
                    processData: false,
                    beforeSend: function (req) {
                        req.setRequestHeader('InstanceCode', config.instanceCode);
                    },

                    success: function (result, statusCode, jqXHR) {
                        deferred.resolve(result, statusCode);
                    },
                    error: function (jqXHR, statusCode, errorThrown) {
                        deferred.reject(errorThrown, statusCode);
                    }
                });
            }).promise();           
        }        

        function cancelSharedDocument(id) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-documents-cancel-shared-document",
                    data: { documentshareId: id },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }        
        function saveNewVersion(documentId) {
            var data = { documentId: documentId };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "save-document-new-version",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function saveDocumentVersion(documentId, documents) {
            //String.format("documents/action/can-{0}", resourceIdSuffix)

            amplify.request.define("save-document-version", "ajax", {
                url: getUrl(String.format("documents/{0}/versions", documentId)),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data.documents);
                }
            });


            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "save-document-version",
                    data: { documents: documents },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function downloadRevision(documentId, revision) {
            ////String.format("documents/action/can-{0}", resourceIdSuffix)
            ////"documents/content/{documentId}/{revision}"

            var url = "";

            if (revision.length === 0) {
                url = String.format("documents/instancecontent/" + config.instanceCode + "/{0}", documentId)
            } else {
                url = String.format("documents/instancecontent/" + config.instanceCode + "/{0}/{1}", documentId, revision);
            }

            url = getUrl(url);

            return url;

            //var url = "";
            //if (revision.length === 0) {
            //    url = "documents/content/{documentId}";
            //} else {
            //    url = String.format("documents/content/{documentId}/{0}",revision);
            //}

            //amplify.request.define("download-revision", "ajax", {
            //    url: getUrl(url),
            //    contentType: "application/json",
            //    dataType: "json",
            //    type: "GET"
            //});

            //return $.Deferred(function (deferred) {
            //    amplify.request({
            //        resourceId: "download-revision",
            //        data: { documentId: documentId },
            //        success: function (result, statusCode) { deferred.resolve(result, statusCode); },
            //        error: function (result, statusCode) { deferred.reject(result, statusCode); }
            //    });
            //}).promise();
        }
        function restoreRevision(documentId, revision) {

            ///documents/action/restore-prior-revision/{documentId}/{revision}
            amplify.request.define("restore-revision", "ajax", {
                url: getUrl(String.format("documents/action/restore-prior-revision/{documentId}/{0}", revision)),
                contentType: "application/json",
                dataType: "json",
                type: "PUT"
            });

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "restore-revision",
                    data: { documentId: documentId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function resendDocumentShareEmailLink(documentshareId, documentsharerecipientId) {
            var data = { documentshareId: documentshareId, documentsharerecipientId: documentsharerecipientId };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-document-resend-share-email-link",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        init();

        return {
            //#region public
            getDocumentDefaultSchema: getDocumentDefaultSchema,
            getLibraryDocumentSchema: getLibraryDocumentSchema,
            getLibraryModifyFieldDocumentSchema: getLibraryModifyFieldDocumentSchema,
            getOpenDocumentBaseUrl: getOpenDocumentBaseUrl,
            getDocumentDetails: getDocumentDetails,
            getDocumentHpvLinks: getDocumentHpvLinks,
            getDocumentPublicLinks: getDocumentPublicLinks,
            getDocumentGeneratedPublicLinks: getDocumentGeneratedPublicLinks,
            updateDocumentField: updateDocumentField,
            updateDocumentClassField: updateDocumentClassField,
            flagDocument: flagDocument,
            unflagDocument: unflagDocument,
            favouriteDocument: favouriteDocument,
            unfavouriteDocument: unfavouriteDocument,
            getDocumentPreview: getDocumentPreview,
            getDocumentsFromFolder: getDocumentsFromFolder,
            getDocumentsCheckedOut: getDocumentsCheckedOut,
            getDocumentDetailsWindows: getDocumentDetailsWindows,
            getDeletedDocumentsByFolderId: getDeletedDocumentsByFolderId,
            getSharedDocuments: getSharedDocuments,
            getSharedDocumentDetails: getSharedDocumentDetails,
            cancelSharedDocument: cancelSharedDocument,

            history: {
                getDocumentHistory: getDocumentHistory,
                downloadRevision: downloadRevision,
                restoreRevision: restoreRevision,
            },

            version: {
                getDocumentVersion: getDocumentVersion,
                saveDocumentVersion: saveDocumentVersion,
                saveNewVersion: saveNewVersion
            },

            actions: {
                canDownload: canDownload,
                canShare: canShare,
                canSaveNewVersion: canSaveNewVersion,
                canCopyDocuments: canCopyDocuments,
                canMoveDocuments: canMoveDocuments,
                canReplaceFile: canReplaceFile,
                canModifyField: canModifyField,
                canCheckout: canCheckout,
                canCheckin: canCheckin,
                canCancelCheckout: canCancelCheckout,
                canDelete: canDelete,
                canUndelete: canUndelete,
                canPurgeDeleted: canPurgeDeleted,
                canRestorePriorRevision: canRestorePriorRevision,

                copyDocuments: copyDocuments,
                copyDocumentsTemplate: copyDocumentsTemplate,
                moveDocuments: moveDocuments,
                deleteDocuments: deleteDocuments,
                undeleteDocuments: undeleteDocuments,
                purgedeletedDocuments: purgedeletedDocuments,
                modifyFieldDocuments: modifyFieldDocuments,
                replaceFileDocuments: replaceFileDocuments,
                checkInDocuments: checkInDocuments,
                cancelCheckOutDocuments: cancelCheckOutDocuments,
                addFileDocuments: addFileDocuments,
                addFileNewVersionDocuments: addFileNewVersionDocuments,
                checkoutDocuments: checkoutDocuments,
                shareDocuments: shareDocuments,                
                flagDocuments: flagDocuments,
                unflagDocuments: unflagDocuments,
                favouriteDocuments: favouriteDocuments,
                unfavouriteDocuments: unfavouriteDocuments,

                getShareWithItems: getShareWithItems,                
                getSharedMessage: getSharedMessage                                
            },

            resendDocumentShareEmailLink: resendDocumentShareEmailLink

            //#endregion
        };

        //#region Internal Methods

        function init() {

            amplify.request.define("get-library-document-schema", "ajax", {
                url: getUrl("documents/libraries/{libraryId}/schema"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-modifyfield-document-schema", "ajax", {
                url: getUrl("documents/libraries/{libraryId}/modifyfieldschema"),
                dataType: "json",
                type: "GET"
            });
            
            amplify.request.define("get-document-default-schema", "ajax", {
                url: getUrl("documents/default/schema"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-document-details", "ajax", {
                url: getUrl("documents/{documentId}/libraries/{libraryId}/details"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-document-details-windows", "ajax", {
                url: getUrl("/documents/{documentId}/detailswindows"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("put-document-hpv-links", "ajax", {
                url: getUrl("/documents/action/documenthpvlinks"),
                contentType: "application/json",
                dataType: "json",                
                dataMap: function (data) {
                    return JSON.stringify(data.documentIds);
                },
                type: "PUT"
            });

            amplify.request.define("put-document-public-links", "ajax", {
                url: getUrl("/documents/action/sharepublic"),
                contentType: "application/json",
                dataType: "json",
                dataMap: function (data) {
                    return JSON.stringify(data);
                },
                type: "PUT"
            });

            amplify.request.define("get-document-generated-public-links", "ajax", {
                url: getUrl("documentshares/publiclinks/{documentShareId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("update-document-field", "ajax", {
                url: getUrl("documents/{documentId}/libraries/{libraryId}/details"),
                contentType: "application/json",
                dataType: "json",
                dataMap: function (data) {
                    return JSON.stringify(data.fieldMap);
                },
                type: "PUT"
            });

            amplify.request.define("favourite-document", "ajax", {
                url: getUrl("documents/{documentId}/favourite"),
                dataType: "json",
                type: "POST"
            });

            amplify.request.define("unfavourite-document", "ajax", {
                url: getUrl("documents/{documentId}/unfavourite"),
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("flag-document", "ajax", {
                url: getUrl("documents/{documentId}/flag"),
                dataType: "json",
                type: "POST"
            });

            amplify.request.define("unflag-document", "ajax", {
                url: getUrl("documents/{documentId}/unflag"),
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("get-document-preview", "ajax", {
                url: getUrl("documents/{documentId}/preview"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-sharewithitems", "ajax", {
                url: getUrl("/documents/action/sharewithitems"),
                dataType: "json",
                type: "GET"
            });

            defineCanPerformActionResource("download");
            defineCanPerformActionResource("share");
            defineCanPerformActionResource("save-new-version");
            defineCanPerformActionResource("copy");
            defineCanPerformActionResource("move");
            defineCanPerformActionResource("replace-file");
            defineCanPerformActionResource("modify-field");
            defineCanPerformActionResource("checkout");
            defineCanPerformActionResource("checkin");
            defineCanPerformActionResource("cancel-checkout");
            defineCanPerformActionResource("delete");
            defineCanPerformActionResource("undelete");
            defineCanPerformActionResource("purge-deleted");
            defineCanPerformActionResource("restore-prior-revision");

            amplify.request.define("copy-documents-template", "ajax", {
                url: getUrl("documents/{folderId}/copy-template-documents"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data.documents);
                }
            });

            amplify.request.define("copy-documents", "ajax", {
                url: getUrl("documents/{folderId}/copy-documents"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data.documents);
                }
            });

            amplify.request.define("move-documents", "ajax", {
                url: getUrl("documents/{folderId}/move-documents"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data.documents);
                }
            });

            definePerformActionResource("delete");
            definePerformActionResource("undelete");
            definePerformActionResource("purge");
            definePerformActionResource("modify-field");
            definePerformActionResource("cancel-checkout");
            definePerformActionResource("share");
            definePerformActionResource("check-out");

            amplify.request.define("get-documents-shared-message", "ajax", {
                url: getUrl("documentshares/recipient/{recipientlinkId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-documents-sharedmails-details", "ajax", {
                url: getUrl("documentshares/list{my}/{lastdays}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-documents-shared-details", "ajax", {
                url: getUrl("documentshares/details/{documentshareId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("put-documents-cancel-shared-document", "ajax", {
                url: getUrl("documentshares/cancel/{documentshareId}"),
                dataType: "json",
                type: "PUT"
            });

            amplify.request.define("get-documents-from-folder", "ajax", {
                url: getUrl("documents/folders/{folderId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-documents-checkedout", "ajax", {
                url: getUrl("documents/checkedout"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-document-version", "ajax", {
                url: getUrl("documents/{documentId}/versions"),
                dataType: "json",
                type: "GET"
            });
            
            amplify.request.define("get-document-history", "ajax", {
                url: getUrl("documents/history/{documentId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("save-document-new-version", "ajax", {
                url: getUrl("documents/action/savenewversion/{documentId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT"
            });

            amplify.request.define("put-document-resend-share-email-link", "ajax", {
                url: getUrl("documentshares/resendemail/{documentshareId}/recipient/{documentsharerecipientId}"),
                dataType: "json",
                type: "PUT"
            });

            amplify.request.define("get-deleted-documents-by-folder-id", "ajax", {
                url: getUrl("documents/deleted/all?page=1&pageSize=10000&filter=folderId~eq~%27{folderId}%27"),
                dataType: "json",
                type: "GET"
            });
        }

        function definePerformActionResource(resourceIdSuffix) {
            amplify.request.define(String.format("{0}-documents", resourceIdSuffix), "ajax", {
                url: getUrl(String.format("documents/action/{0}", resourceIdSuffix)),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    if (typeof (data) === "string") {
                        return data;
                    } else {
                        return JSON.stringify(data.documents);
                    }

                }
            });
        }

        function defineCanPerformActionResource(resourceIdSuffix) {
            amplify.request.define(String.format("document-action-can-{0}", resourceIdSuffix), "ajax", {
                url: getUrl(String.format("documents/action/can-{0}", resourceIdSuffix)),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data.documents);
                }
            });
        }

        function canPerformAction(resourceIdSuffix, documents) {

            documents =_.map(documents, function (documentInfo) {
                return {
                    docIdVersionId: documentInfo.docIdVersionId, //addition for #download links
                    documentId: documentInfo.documentId,
                    folderId: documentInfo.folderId
                };
            });
            
            var deferred = $.Deferred();
            amplify.request({
                resourceId: String.format("document-action-can-{0}", resourceIdSuffix),
                data: { documents: documents },
                success: function(result, statusCode) { deferred.resolve(result, statusCode); },
                error: function(result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }

        function performAction(resourceIdSuffix, documents) {            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: String.format("{0}-documents", resourceIdSuffix),
                    data: { documents: documents },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function performAddReplaceFileCheckOutAction(url, data) {            
            return $.Deferred(function (deferred) {
                $.ajax({
                    url: url,
                    type: "POST",
                    data: data,
                    mimeType: "multipart/form-data",
                    contentType: false,
                    cache: false,
                    processData: false,
                    beforeSend: function(req) {
                        req.setRequestHeader('InstanceCode', config.instanceCode);
                    },
                
                    success: function (result, statusCode, jqXHR) {
                        deferred.resolve(result, statusCode);
                    },
                    error: function (jqXHR, statusCode, errorThrown) {
                        deferred.reject(errorThrown, statusCode);
                    }
                });
            }).promise();
        }

        function performModifyAction(resourceIdSuffix, toModify, documents) {

            documents = _.map(documents, function (documentInfo) {
                return {
                    documentId: documentInfo.documentId,
                    folderId: documentInfo.folderId
                  };
            });


            var dataToPass = String.format("{fieldmap:{0}, documents:{1}" + "}", toModify, JSON.stringify(documents));

            var deferred = $.Deferred();

            amplify.request({
                resourceId: String.format("{0}-documents", resourceIdSuffix),
                data: dataToPass,
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }
        
        function markDocument(documentId, resourceId) {
            var data = { documentId: documentId };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: resourceId,
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function utf8_to_b64(str) {
            return window.btoa(unescape(encodeURIComponent(str)));
        }

        function b64_to_utf8(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        function getUrl(action) {
            return config.webApiUrl + action;
        }

        //#endregion
    }
);

